import { createResource, createEndpoint } from './Schema';
import { FriendshipModel } from './Schema/Models';
import api from './Schema/Api';

/*
 * static s'applique au model
 * methods s'applique à la resource
 */
const sync = false;
const methods = {};

const FriendshipResource = createResource(api, FriendshipModel, {
  static: { sync },
  methods,
});

export const Friendship = createEndpoint(FriendshipResource, '', {
  static: {},
});
